import { LocalDate } from 'js-joda';

import { CheckinScanArguments, ToggleCheckinArguments } from 'types/checkin';
import { noop } from 'es-toolkit';
import AppConstants from 'constants/AppConstants';
import dashboardProtos from 'utils/protos';

const { CheckinRequest } = dashboardProtos;

export interface CheckinActions {
  checkinScan(config: CheckinScanArguments): ApiAction;
  checkinScanClientFail(): BaseTockAction;
  checkinScanResultClear(): BaseTockAction;
  toggleCheckin(config: ToggleCheckinArguments): ApiAction;
  changeCheckinDate(date: LocalDate): Promise<BaseTockAction>;
  openCheckinStatusDetail(): BaseTockAction;
  closeCheckinStatusDetail(): BaseTockAction;
}

export function checkinScan(config: CheckinScanArguments): ApiAction {
  const { purchaseToken, isCheckingIn, isValidationCheck } = config;
  return {
    TockApi: {
      postProto: `/checkin`,
      type: AppConstants.CHECKIN_SCAN,
      request: CheckinRequest.fromObject({
        purchaseToken,
        isCheckingIn,
        isValidationCheck,
      }),
      // TODO: CHANGE TO QR specific error
      onError: {
        3050: noop,
      },
    },
  };
}

export function checkinScanClientFail(): BaseTockAction {
  return {
    type: AppConstants.CHECKIN_SCAN_FAILED,
  };
}

export function checkinScanResultClear(): BaseTockAction {
  return {
    type: AppConstants.CHECKIN_SCAN_RESULT_CLEAR,
  };
}

export function toggleCheckin(config: ToggleCheckinArguments): ApiAction {
  const { purchaseId, ticketIndex, isCheckingIn, isCheckingInEntirePurchase } = config;
  return {
    TockApi: {
      postProto: '/checkin',
      type: AppConstants.CHECKIN_SCAN,
      request: CheckinRequest.fromObject({
        purchaseId,
        ticketIndex,
        isCheckingIn,
        isCheckingInEntirePurchase,
      }),
    },
  };
}

export function changeCheckinDate(date: LocalDate): Promise<BaseTockAction> {
  return Promise.resolve({
    type: AppConstants.CHECKIN_DATE_CHANGE,
    payload: date,
  });
}

export function openCheckinStatusDetail(): BaseTockAction {
  return {
    type: AppConstants.CHECKIN_TOGGLE_EXPAND_STATUS_DETAIL,
    payload: true,
  };
}

export function closeCheckinStatusDetail(): BaseTockAction {
  return {
    type: AppConstants.CHECKIN_TOGGLE_EXPAND_STATUS_DETAIL,
    payload: false,
  };
}
